import { render, staticRenderFns } from "./EmergencyBox.vue?vue&type=template&id=a33fd7b2"
import script from "./EmergencyBox.vue?vue&type=script&lang=js"
export * from "./EmergencyBox.vue?vue&type=script&lang=js"
import style0 from "./EmergencyBox.vue?vue&type=style&index=0&id=a33fd7b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports